import { GET_PROJECTS_SUCCESS, ProjectsActionTypes } from './types';
import { ProjectsDto } from '../../api/LRPProxy';

export function getProjectsList(projects: ProjectsDto[]): ProjectsActionTypes {
  return {
    type: GET_PROJECTS_SUCCESS,
    payload: projects,
  };
}
